<script setup>
import { NuxtLink } from "#components"
defineProps({ to: { type: [String, Object], default: null }, label: { type: String, default: "بازگشت" } })
defineEmits(["click"])
</script>
<template>
  <component :is="to ? NuxtLink : 'button'" :to="to || undefined" :type="to ? undefined : 'button'"
    class="app-back-button" :aria-label="label" @click="$emit('click', $event)">
    <VIcon icon="tabler-arrow-right" size="23" />
  </component>
</template>
<style scoped>
.app-back-button{position:relative;display:grid;place-items:center;width:34px;height:34px;min-width:34px;flex:0 0 34px;padding:0;border:0;border-radius:50%;background:rgba(var(--v-theme-primary),.07);color:rgb(var(--v-theme-primary));box-shadow:none;cursor:pointer;text-decoration:none;transition:background-color .15s}
.app-back-button::before{content:"";position:absolute;inset:-5px;border-radius:50%}
.app-back-button:hover{background:rgba(var(--v-theme-primary),.13)}
.app-back-button:focus-visible{outline:2px solid rgb(var(--v-theme-primary));outline-offset:3px}
.app-back-button:disabled{opacity:.45;cursor:default}
</style>
